import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Alert from 'react-s-alert';
import queryString from 'query-string';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Pagination from 'modules/common/components/Pagination';
import { numberWithCommas } from 'helper';

import * as c from '../constant';
import * as action from '../action';
import history from '../../../../../history';

function AmnestyContainer({ getAmnestyList, amnestyList, isLoading, pager }) {
  const [formData, setFormData] = useState({
    date_from: '',
    date_to: '',
  });
  const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    getAmnestyList();
  }, []);

  const syncFilters = (params) => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleChangePage = (page) => {
    getAmnestyList({ ...query, page });
    syncFilters({ ...query, page });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      if (
        key === 'date_from' &&
        `${moment(new Date(value)).format('YYYY/MM/DD')}` >
          `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
      ) {
        Alert.warning('Invalid filter, Date From is greater than Date To');

        setFormData({
          ...formData,
          [key]: '',
        });
        return;
      }

      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleSubmit = (e) => {
    if (
      `${moment(new Date(_.get(formData, 'date_from'))).format('YYYY/MM/DD')}` >
      `${moment(new Date(_.get(formData, 'date_to'))).format('YYYY/MM/DD')}`
    ) {
      Alert.warning(
        'Invalid filter, Date From is greater than selected Date To'
      );
      setFormData({
        ...formData,
        date_from: '',
      });
    }

    e.preventDefault();
    const newData = {
      date_from: `${moment(_.get(formData, 'date_from')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      date_to: `${moment(_.get(formData, 'date_to')).format(
        'YYYY-MM-DD'
      )} 23:59:00`,
    };
    getAmnestyList(newData);
    syncFilters(newData);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      date_from: '',
      date_to: '',
    });
    syncFilters({
      date_from: '',
      date_to: '',
    });
    getAmnestyList();
    history.replace({ pathname: window.location.pathname });
  };

  const getAmnestyReports = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/administrators/ovrs/reports/tax_amnesty/export`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      date_from: _.get(formData, 'date_from')
        ? `${moment(_.get(formData, 'date_from')).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        : '',
      date_to: _.get(formData, 'date_to')
        ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')} 23:59:00`
        : '',
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="mb-3">
        <div className="row p-3">
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 px-1">
            <div className="form-input-group">
              <label className="label-reports">Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
          </div>
          <div className="col-12 col-xl-4 d-flex align-items-end px-1">
            <div className="form-input-group">
              <button
                disabled={
                  `${moment(new Date(_.get(formData, 'date_from'))).format(
                    'YYYY/MM/DD'
                  )}` >
                    `${moment(new Date(_.get(formData, 'date_to'))).format(
                      'YYYY/MM/DD'
                    )}` ||
                  _.isEmpty(_.get(formData, 'date_from')) ||
                  _.isEmpty(_.get(formData, 'date_to'))
                }
                type="submit"
                className="btn btn-md button-filter"
              >
                <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
              </button>
            </div>
            <div className="form-input-group pl-2">
              <button
                onClick={onClear}
                type="button"
                className="btn btn-md button-clear"
              >
                <i className="fas fa-times" /> &nbsp;&nbsp; Clear
              </button>
            </div>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-2 d-flex justify-content-end px-1">
            <div className="form-input-group pl-2 mr-3">
              <a
                href={getAmnestyReports()}
                className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
                style={{ color: 'white' }}
              >
                <i className="fas fa-cloud-download-alt mr-2" />
                Download
              </a>
            </div>
          </div>
        </div>
      </form>
      {isLoading ? (
        <div
          className="loading d-flex text-center justify-content-center align-items-center"
          style={{ height: '500px' }}
        >
          <div className="spinner text-center ">
            <span className="fas fa-5x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-sm table-bordered table-hover">
            <thead className="table-header">
              <tr>
                <th className="w-5">OVR No.</th>
                <th>Last Name</th>
                <th>First Name</th>
                <th>Middle Name</th>
                <th>Tax Year</th>
                <th>Gross Amount</th>
                <th>Amnesty Amount</th>
                <th>Net Amount</th>
              </tr>
            </thead>
            <tbody className="table-details">
              {amnestyList.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>{_.get(item, 'attributes.ovr_number') || '---'}</td>
                    <td>{_.get(item, 'attributes.last_name') || '---'}</td>
                    <td>{_.get(item, 'attributes.first_name') || '---'}</td>
                    <td>{_.get(item, 'attributes.middle_name') || '---'}</td>
                    <td>{_.get(item, 'attributes.year') || '---'}</td>
                    <td>
                      PHP{' '}
                      {numberWithCommas(
                        _.get(item, 'attributes.gross_amount')?.toFixed(2)
                      ) || '---'}
                    </td>
                    <td>
                      PHP{' '}
                      {numberWithCommas(
                        _.get(item, 'attributes.amnesty_amount')?.toFixed(2)
                      ) || '---'}
                    </td>
                    <td>
                      PHP{' '}
                      {numberWithCommas(
                        _.get(item, 'attributes.net_amount')?.toFixed(2)
                      ) || '---'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      <div className="list-pagination">
        {pager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={pager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
        )}
      </div>
    </React.Fragment>
  );
}

AmnestyContainer.propTypes = {
  getAmnestyList: PropTypes.instanceOf(Function).isRequired,
  amnestyList: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  amnestyList: _.get(api, `${c.AMNESTY_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.AMNESTY_LIST) > -1,
  pager: _.get(api, `${c.AMNESTY_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(AmnestyContainer);
